export const activeRmDepartmentNames = ['"Anchor Sales", "Sales", "FI Sales"'];
